import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query";

import { addManagedLiveReportViewers } from "../../client/manager/live-report";
import { LiveReportLink } from "../../models/live-report";
import { managedLiveReportLinksQueryKey } from "./useManagedLiveReportLinks";
import { useTixologiTokenRefresher } from "./useTixologiTokenRefresher";

interface AddViewersVariables {
  id: number;
  emails: string[];
}

export function useAddManagedLiveReportViewers(
  partnerId: string | undefined,
  isComedian = false
): UseMutationResult<LiveReportLink, Error, AddViewersVariables> {
  const queryClient = useQueryClient();
  const { token, refresh } = useTixologiTokenRefresher(partnerId, isComedian);

  return useMutation({
    mutationFn: async ({ id, emails }: AddViewersVariables) => {
      const initial = token ?? (await refresh());
      if (!initial) throw new Error("Tixologi token not available");
      return addManagedLiveReportViewers(initial, id, emails, refresh);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: managedLiveReportLinksQueryKey(partnerId),
      });
    },
  });
}
